import { useReCaptcha } from 'next-recaptcha-v3';

import { awaitAnimationFrame } from '@dop/shared/helpers/awaitAnimationFrame';
import {
	environment,
	hostEnv,
} from '@/globals/config/helpers/configEnvironment';

const fakeExecute = async () => 'NO.NO.NO.TOKEN';

export const useGoogleReCaptcha = () => {
	const { executeRecaptcha } = useReCaptcha();

	if (process.env.NODE_ENV === 'test') {
		return fakeExecute;
	}

	if (
		(environment !== 'prd' || hostEnv === 'localhost') &&
		typeof window !== 'undefined' &&
		window.Cypress
	) {
		// During Cypress testing, allow for quick testing;
		return fakeExecute;
	}

	return async (action: string) => {
		await awaitAnimationFrame();
		return await executeRecaptcha(action);
	};
};
